module.exports = __webpack_public_path__ + "img/achievement1.94eb4e1d.jpg";